export default {
	institutionData: (state) => state.institution?.data ? state.institution.data : null,
	institutionId: (state) => state.institution?.data?.loanInstitutionId ? state.institution.data.loanInstitutionId : null,
	institutionPackagesData: (state) => state.institution?.packages?.data ? state.institution.packages.data : [],
	institutionPackagesTotalRows: (state) => state.institution?.packages?.totalRows ? state.institution.packages.totalRows : 0,
	institutionStaffsData: (state) => state.institution?.staffs ? state.institution.staffs : [],
	institutionStaffsTotalRows: (state) => state.institution?.staffs ? state.institution.staffs.length : 0,
}
